import {
  setupLookups,
} from "App/shk-form-tab";
import {
  SICHTBARKEIT,
} from "App/constants";

export const schema = {
  displayName: "Notiz",
  defaultSort: [{ field: "no_crdate", descending: true }],
  filters: {},
  table: [
    {
      field: "no_text",
      display: "Notiz",
      type: "markdown",
      sortable: true,
      required: true,
    },
    {
      field: "no_ksiid",
      display: "Sichtbarkeit",
      lookup: "k_sichtbarkeit.select",
      default: SICHTBARKEIT.SICHTBAR_FÜR_MICH,
      required: true,
      sortable: true,
    },
    {
      field: "no_crdate",
      display: "Erstellt am",
      type: "date",
      readonly: true,
      hideFromEditor: () => true,

    },
    {
      field: "no_upddate",
      display: "Geändert am",
      type: "date",
      readonly: true,
      hideFromEditor: () => true,
    },
    {
      field: "no_nid",
      display: "Benutzer",
          // lookup: {settings: lookupNutzer },
      hideFromEditor: () => true,
    },
  ],
};

setupLookups(schema);
